module.exports = __webpack_public_path__ + "img/logo-sap@2x.fe8c9cb2.png";